import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { useAdminAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { TIDS } from "@/constants/testIds";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const res = await login(undefined, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setErr(res.error);
  };

  return (
    <AppLayout>
      <div className="rrdc-card p-6 max-w-md mx-auto">
        <div className="flex items-center justify-center mb-2">
          <img src="/rrdc-logo.png" alt="Rolling River Day Camp" className="h-20 w-20 rounded-full" />
        </div>
        <div className="text-xs uppercase tracking-widest text-[#2F50A1] font-semibold text-center">Office login</div>
        <h1 className="rrdc-heading text-2xl font-bold mt-1 text-[#111827] text-center">Admin sign in</h1>
        <p className="text-sm text-[#4B5563] mt-2 text-center no-hyphens">
          Enter the office password to continue.
        </p>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              className="h-12 mt-1"
              autoComplete="current-password"
              autoFocus
              data-testid={TIDS.adminPassword}
            />
          </div>
          {err ? <div className="text-sm text-red-600">{err}</div> : null}
          <Button
            type="submit"
            disabled={busy || !password}
            className="w-full h-12 rrdc-btn-primary rounded-xl"
            data-testid={TIDS.adminSubmit}
          >
            {busy ? "Signing in" : "Sign in"}
          </Button>
        </form>
      </div>
    </AppLayout>
  );
}
